import React from "react";
import Seo from "@/utils/seo";
import Banner from "@/components/pages/home/banner";
import Head from "next/head";
import About from "@/components/pages/home/about";
import OurWork from "@/components/pages/home/our-work";
import { getJsonLd } from "@/utils/get-jsonld";
export default function Home() {
  const seo = {
    slug: "/",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd("")),
          }}
        />
      </Head>
      <Banner />
      <About />
      <OurWork />
    </>
  );
}
